import { useSmartSignalsContext } from '../context/BotdContext'
import { getCountryRegion, Region } from '../helpers/region'

export const useUserLocation = () => {
  const { currentEvent, visitorId } = useSmartSignalsContext()
  const geolocation = currentEvent?.ip_info?.v4?.geolocation ?? currentEvent?.ip_info?.v6?.geolocation
  const userRegion = geolocation?.country_code?.toUpperCase()
  const userCountry = geolocation?.country_name?.toUpperCase()
  const countryRegion = userRegion ? getCountryRegion(userRegion) : Region.AMER
  const isEuUser = countryRegion === Region.EMEA
  return { userRegion, userCountry, countryRegion, visitorId, isEuUser }
}
